/** Timeout for the whole send pipeline (Firestore + PDF upload + Cloud Function). */
export const SEND_EMAIL_FLOW_TIMEOUT_MS = 120_000

/**
 * Races a promise against a timeout so Firestore retries cannot stall the UI indefinitely.
 */
export function withTimeout(promise, ms, timeoutMessage = 'The operation timed out. Please try again.') {
  return new Promise((resolve, reject) => {
    const id = setTimeout(() => {
      reject(Object.assign(new Error(timeoutMessage), { code: 'client-timeout' }))
    }, ms)
    promise.then(
      (v) => {
        clearTimeout(id)
        resolve(v)
      },
      (e) => {
        clearTimeout(id)
        reject(e)
      }
    )
  })
}

const NETWORKISH = /(network|failed to fetch|fetch|offline|internet|dns|name not resolved|err_name|connection|unreachable)/i

/**
 * User-facing copy for Firestore / offline / timeout failures.
 */
export function friendlyFirestoreOrNetworkMessage(err, fallback) {
  const code = err?.code
  const msg = String(err?.message || '')
  if (
    code === 'unavailable' ||
    code === 'deadline-exceeded' ||
    code === 'client-timeout' ||
    code === 'resource-exhausted' ||
    code === 'cancelled' ||
    NETWORKISH.test(msg)
  ) {
    return 'We could not reach the server. Check your internet connection and try again. If the problem continues, refresh the page.'
  }
  return fallback
}
